import { LegalYandexWordFields } from "../const/legal_yandex_word_fields";

export const hrLoginFields = [
    "hr_reg_postal_code",
    "hr_phone",
    "hr_reg_city",
    "id_doc_dep_code",
    "hr_country_of_birth",
    "hr_address_c",
    "id_doc_type",
    "hr_fio_acc",
    "hr_fio_prepos",
    "hr_town_of_birth",
    "hr_first_name",
    "hr_address_r",
    "hr_reg_apartment",
    "hr_marital_status",
    "hr_reg_town",
    "hr_reg_street",
    "hr_snils",
    "hr_business_group_id",
    "hr_name_en",
    "hr_business_group_name",
    "hr_tk_status_name",
    "hr_login",
    "hr_middle_names",
    "hr_fio",
    "hr_fio_dat",
    "hr_address",
    "id_doc_issued_by",
    "hr_tk_status_code",
    "hr_citizenship",
    "hr_fio_inst",
    "id_doc_date_from",
    "hr_iofamily",
    "hr_reg_country",
    "hr_job_name",
    "hr_sex",
    "hr_reg_combination",
    "id_doc_full",
    "hr_last_name",
    "hr_birth_date",
    "hr_inn",
    "id_doc_series",
    "hr_marital_status_name",
    "hr_reg_region",
    "hr_familyio",
    "id_doc_number",
    "hr_email",
    "hr_fio_gen",
    "hr_reg_house"
];


export const hrQualificationFields = [
    "hr_qualification_speciality",
    "hr_qualification_establishment",
    "hr_qualification_doc_type",
    "hr_qualification_doc",
    "hr_qualification_awarded_date",
    "hr_qualification_type",
    "hr_qualification_okso",
    "hr_qualification_name"
];

export const hrAccountFields = [
    "hr_account_bic",
    "hr_account_bank",
    "hr_account_percentage",
    "hr_account_bank_name",
    "hr_account_priority",
    "hr_account_corr",
    "hr_account_pers"
];

export const hrSubpoenaFields = [
    "subpoena_receipt_date",
    "subpoena_military_office",
    "subpoena_military_office_address",
    "subpoena_type",
    "subpoena_reason",
    "subpoena_appearence_date_time"
]

export const hrMilitaryFields = [
    "hr_military_staff",
    "hr_military_rank",
    "hr_military_doc_type",
    "hr_military_doc_date",
    "hr_military_speciality",
    "hr_military_issued_by",
    "hr_military_doc",
    "hr_military_office",
    "hr_military_reserve_category",
    "hr_military_worth_category"
]

export const hrLoanFields = [
    "hr_loan_date",
    "hr_loan_number",
    "hr_loan_purpose"
]

export const hrContactFields = [
    "hr_contact_date_start",
    "hr_contact_type",
    "hr_contact_full_name",
    "hr_contact_date_of_birth"
]

export const hrAssignmentsFields = [
    "hr_general_visa_job_inst",
    "hr_assg_job_name_gen",
    "hr_primary_flag",
    "hr_employee_number",
    "hr_general_visa_job_prepos",
    "hr_assignment_number",
    "hr_general_visa_gen",
    "hr_assg_job_name_dat",
    "hr_dept_full_name",
    "hr_tax_unit_full_name",
    "hr_general_visa_job_acc",
    "hr_tax_unit_id",
    "hr_general_visa_fio",
    "hr_general_visa_snils",
    "hr_general_visa_familyio",
    "hr_assg_job_name_prepos",
    "hr_general_visa_acc",
    "hr_it_start_date",
    "hr_general_visa_job",
    "hr_general_visa_job_gen",
    "hr_general_visa_inst",
    "hr_general_visa_job_dat",
    "hr_assg_job_name_inst",
    "hr_contract_number",
    "hr_assg_job_name",
    "hr_general_visa_dat",
    "hr_general_visa_iofamily",
    "hr_contract_date",
    "hr_assg_job_name_acc",
    "hr_general_visa_prepos",
    "hr_dept_short_name",
    "hr_it_num",
    "hr_dept_manag_name",
    "hr_division",
    "hr_tax_unit_short_name"
]

export const yandexOrganizationFields = [
    "id",
    "ya_name",
    "ya_full_name",
    "ya_inn",
    "ya_address",
    "ya_address_eng",
    "ya_system_name",
    "ya_reg_num",
    "ya_org_id",
    "ya_bg_id",
    "ya_eng_name_full",
    "ya_eng_name_short",
    "ya_reg_date",
    "ya_kpp",
    "ya_kpp_main",
    "ya_oktmo",
    "ya_okpo",
    "ya_general_visa_login",
    "ya_general_visa_fio",
    "ya_general_visa_familyio",
    "ya_general_visa_iofamily",
    "ya_general_visa_gen",
    "ya_general_visa_dat",
    "ya_general_visa_acc",
    "ya_general_visa_inst",
    "ya_general_visa_prepos",
    "ya_general_visa_job",
    "ya_general_visa_job_gen",
    "ya_general_visa_job_dat",
    "ya_general_visa_job_acc",
    "ya_general_visa_job_inst",
    "ya_general_visa_job_prepos",
    "ya_general_visa_last_name",
    "ya_general_visa_first_name",
    "ya_general_visa_middle_names",
    "ya_general_visa_birth_date",
    "ya_general_visa_inn",
    "ya_general_visa_snils",
    "ya_general_visa_citizenship",
    "ya_org_country",
    "ya_org_region",
    "ya_org_area",
    "ya_org_town",
    "ya_org_settlement",
    "ya_org_street",
    "ya_org_house",
    "ya_org_building",
    "ya_org_apartment",
    "ya_org_postal_code",
    "ya_org_combination",
    "ya_it_num",
    "ya_it_start_date",
    "isDefault",
    "isRead"
]

export const yandexBankFields = [
    "ya_bank_name",
    "ya_bic",
    "ya_corr_account",
    "ya_payment_account"
]

export const legalYandexBankFields = [
    "ya_account_type",
    "ya_account_currency",
    "ya_bank_name",
    "ya_bic",
    "ya_payment_account",
    "ya_corr_account",
    "ya_bank_iban",
    "ya_bank_swift",
    "ya_bank_chips",
    "ya_bank_aba",
    "ya_account_transit",
    "ya_bank_address",
    "ya_bank_intermediary_bic",
    "ya_correspondent_bank_swift",
    "ya_correspondent_bank",
    "ya_correspondent_bank_address",
    "ya_correspondent_bank_account",
    "ya_bank_inn",
    "ya_bank_mfo",
    "ya_bank_comment",
]

/** Порядок полей для Legal Yandex: как в `LegalYandexWordFields` (enum — единственный источник). */
export const fullYandexLegalFields: string[] = Object.values(LegalYandexWordFields) as string[]

export const legalYandexOrganizationFields: string[] = fullYandexLegalFields.filter(
    (f) => !legalYandexBankFields.includes(f)
)
